import moment from 'moment';

const getDateRangeText = (dateRange) => {
  const startDate = moment(dateRange?.startDate).format('DD MMM YYYY');
  const endDate = moment(dateRange?.endDate).format('DD MMM YYYY');

  return `${startDate} - ${endDate}`;
};

export default getDateRangeText;
